import React from 'react'
import { Row, Col } from 'reactstrap'
import cn from 'classnames'
import template1 from '../../img/template-1.svg'
import template2 from '../../img/template-2.svg'
import template3 from '../../img/template-3.svg'
import template4 from '../../img/template-4.svg'

export function TemplateForm({dispatch, template}) {
  const templates = [
    {
      title: 'Estilo 1',
      image: template1,
      current: 'templateOne'
    },
    {
      title: 'Estilo 2',
      image: template2,
      current: 'templateTwo'
    },
    {
      title: 'Estilo 3',
      image: template3,
      current: 'templateThree'
    },
    {
      title: 'Estilo 4',
      image: template4,
      current: 'templateFour'
    },

  ]

  function getTemplate(event) {
    let template = event.target.closest('.template-tmb').id;
    dispatch({type: 'template', template: template})
  }

  const rows = templates.reduce(function(result, value, index, array) {
    if (index % 2 === 0) result.push(array.slice(index, index + 2));
    return result;
  }, []);

  return (
    <>
      <h3 className='mb-4'>Escoge un estilo</h3>
      {rows.map((col, i) => (
        <Row key={i}>
          {col.map(({title, image, current}, index) => (
            <Col md='6' className='mb-3' key={index}>
              <div className='mb-2'>{title}</div>
              <div className={cn('template-tmb', {active: template === current})} id={current} onClick={getTemplate}>
                <img className='img-fluid' src={image} alt={title} />
              </div>
            </Col>
          ))}
        </Row>
      ))}
    </>
  )
}